import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1343397e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "container-fluid",
  style: {"padding":"0 10%"}
}
const _hoisted_3 = { class: "jumbotron" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Настройки")
], -1))
const _hoisted_6 = { class: "col-2" }
const _hoisted_7 = { class: "Settings-buttons" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Свойство номенклатуры", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Нормативный отступ в контейнерах ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Нормативное смещение в контейнерах ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Тип марджина", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Вариант расчета не погруженного остатка у заказа ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Вариант отображения объема и веса в схемах погрузки ", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "URL адрес сервера", -1))
const _hoisted_19 = {
  key: 0,
  class: "Changes-warning"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Сохранить ", -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_EnumControl = _resolveComponent("EnumControl")!
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_SettingsInfoDialog = _resolveComponent("SettingsInfoDialog")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isShowSettings)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("header", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_DxButton, {
                    class: "float-end",
                    width: 36,
                    type: "normal",
                    icon: "info",
                    hint: "Справка",
                    "styling-mode": "contained",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowInfo($event)))
                  })
                ])
              ])
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onFormSubmit($event)))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_DxCheckBox, {
                      class: "Settings-checkbox",
                      value: _ctx.model.useStandardSizes,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.useStandardSizes) = $event)),
                      onValueChanged: _ctx.haveChanges,
                      text: "Использовать нормативные размеры по типу пакета"
                    }, null, 8, ["value", "onValueChanged"]),
                    _createVNode(_component_DxCheckBox, {
                      class: "Settings-checkbox",
                      value: _ctx.model.isUseShipments,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.isUseShipments) = $event)),
                      text: "Показывать вкладку \"отгрузки\"",
                      onValueChanged: _ctx.haveChanges
                    }, null, 8, ["value", "onValueChanged"]),
                    _hoisted_10,
                    _createVNode(_component_CatalogueSelectControl, {
                      class: "ModelField-selectControl",
                      stylingMode: "outlined",
                      id: _ctx.model.nomenclatureFeatureId,
                      "onUpdate:id": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.nomenclatureFeatureId) = $event)),
                      desc: _ctx.model.nomenclatureFeatureDescription,
                      "onUpdate:desc": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.nomenclatureFeatureDescription) = $event)),
                      displayDescField: "name",
                      keyField: "id",
                      catalogueComponentName: "catalogues/FeatureCatalogue/FeatureCatalogue",
                      hasEmptyValue: true,
                      onChanged: _ctx.haveChanges
                    }, null, 8, ["id", "desc", "onChanged"]),
                    _hoisted_11,
                    _createVNode(_component_CatalogueSelectControl, {
                      class: "ModelField-selectControl",
                      stylingMode: "outlined",
                      id: _ctx.model.gapId,
                      "onUpdate:id": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.gapId) = $event)),
                      desc: _ctx.model.gapDescription,
                      "onUpdate:desc": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.gapDescription) = $event)),
                      displayDescField: "name",
                      keyField: "id",
                      catalogueComponentName: "catalogues/GapCatalogue/GapCatalogue",
                      hasEmptyValue: true,
                      onChanged: _ctx.haveChanges
                    }, null, 8, ["id", "desc", "onChanged"]),
                    _hoisted_12,
                    _createVNode(_component_CatalogueSelectControl, {
                      class: "ModelField-selectControl",
                      stylingMode: "outlined",
                      id: _ctx.model.displacementId,
                      "onUpdate:id": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.displacementId) = $event)),
                      desc: _ctx.model.displacementDescription,
                      "onUpdate:desc": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.displacementDescription) = $event)),
                      displayDescField: "name",
                      keyField: "id",
                      catalogueComponentName: "catalogues/DisplacementCatalogue/DisplacementCatalogue",
                      hasEmptyValue: true,
                      onChanged: _ctx.haveChanges
                    }, null, 8, ["id", "desc", "onChanged"]),
                    _createElementVNode("div", null, [
                      _hoisted_13,
                      _createVNode(_component_EnumControl, {
                        class: "ModelField-control",
                        id: _ctx.model.marginUnitType,
                        "onUpdate:id": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.marginUnitType) = $event)),
                        desc: _ctx.model.marginUnitTypeDescription,
                        "onUpdate:desc": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.marginUnitTypeDescription) = $event)),
                        onChanged: _ctx.haveChanges,
                        enumType: "marginUnitType",
                        stylingMode: "outlined"
                      }, null, 8, ["id", "desc", "onChanged"])
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_14,
                      _createVNode(_component_EnumControl, {
                        class: "ModelField-control",
                        id: _ctx.model.calculationType,
                        "onUpdate:id": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.calculationType) = $event)),
                        desc: _ctx.model.calculationTypeDescription,
                        "onUpdate:desc": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.calculationTypeDescription) = $event)),
                        onChanged: _ctx.haveChanges,
                        enumType: "calculationType",
                        stylingMode: "outlined"
                      }, null, 8, ["id", "desc", "onChanged"])
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_15,
                      _createVNode(_component_EnumControl, {
                        class: "ModelField-control",
                        id: _ctx.model.volumeWeightDisplayType,
                        "onUpdate:id": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.volumeWeightDisplayType) = $event)),
                        desc: _ctx.model.volumeWeightDisplayTypeDescription,
                        "onUpdate:desc": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.volumeWeightDisplayTypeDescription) = $event)),
                        onChanged: _ctx.haveChanges,
                        enumType: "volumeWeightDisplayType",
                        stylingMode: "outlined"
                      }, null, 8, ["id", "desc", "onChanged"])
                    ]),
                    (_ctx.isShowServerSettings)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_component_DxCheckBox, {
                            class: "Settings-checkbox",
                            value: _ctx.model.useExternalSolver,
                            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.model.useExternalSolver) = $event)),
                            onValueChanged: _ctx.haveChanges,
                            text: "Использовать отдельный сервер для решателя"
                          }, null, 8, ["value", "onValueChanged"]),
                          (_ctx.model.useExternalSolver)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _hoisted_18,
                                _createVNode(_component_TextControl, {
                                  class: "ModelField-control",
                                  stylingMode: "outlined",
                                  placeholder: "URL адрес сервера...",
                                  disabled: !_ctx.model.useExternalSolver,
                                  "show-clear-button": true,
                                  hasEmptyValue: !_ctx.model.useExternalSolver,
                                  value: _ctx.model.externalSolverUrl,
                                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model.externalSolverUrl) = $event)),
                                  onChanged: _ctx.haveChanges,
                                  validationGroup: null
                                }, null, 8, ["disabled", "hasEmptyValue", "value", "onChanged"])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.model.useExternalSolver)
                            ? (_openBlock(), _createBlock(_component_DxButton, {
                                key: 1,
                                type: "default",
                                text: "Тест соединения",
                                onClick: _ctx.onCheckConnection
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.changes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Изменения вступят в силу после сохранения "))
                  : _createCommentVNode("", true),
                _createVNode(_component_DxButton, {
                  "styling-mode": "outlined",
                  class: "Settings-save",
                  type: "default",
                  "use-submit-behavior": true
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("span", null, [
                      (_ctx.saving)
                        ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                            key: 0,
                            icon: "circle-notch",
                            spin: ""
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_20
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxButton, {
                  "styling-mode": "outlined",
                  class: "Settings-reset",
                  type: "default",
                  text: "Отмена",
                  onClick: _ctx.reset,
                  disabled: !_ctx.changes
                }, null, 8, ["onClick", "disabled"])
              ])
            ], 32),
            _createVNode(_component_SettingsInfoDialog, { ref: "infoDialog" }, null, 512)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DxPopup, {
      visible: _ctx.isShowConnectionDialog,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.isShowConnectionDialog) = $event)),
      width: 300,
      height: 130,
      "show-title": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxToolbarItem, {
          options: _ctx.closeButtonOptions,
          widget: "dxButton",
          location: "after",
          toolbar: "bottom"
        }, null, 8, ["options"]),
        _createElementVNode("div", null, [
          (_ctx.isConnected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Соединение установлено"))
            : _createCommentVNode("", true),
          (!_ctx.isConnected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Соединение не установлено"))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}